export const dataLocalizationPolicy2025 = `
# Data Localization Policy

> Last updated: November 1, 2025


This data localization policy is a legally binding document. Please read it carefully. This document complements the endress+hauser master service agreement. by accepting the data localization policy, by (1) clicking a box or button indicating acceptance, (2) placing an order pursuant to a quotation referring to this data localization policy, or (3) using free service, you agrees to the conditions defined in this document and the conditions set forth in the endress+hauser master service agreement.

## 1. Introduction

This Data Localization Policy outlines the requirements and procedures for storing and processing data within the geographical boundaries of specific countries to comply with local regulations. This policy applies to all data collected, processed, and stored by Endress+Hauser in the context of Netilion and the corresponding Description of Service in countries with data localization requirements. This data localization policy also complements the provisions of the privacy policy and the Master Service Agreement for Netilion.


## 2. Definitions

Data Localization: The practice of storing and processing data within the geographical boundaries of a specific country as mandated by local laws.

Personal Data: Any information relating to an identified or identifiable natural person.

Sensitive Data: Data that requires higher levels of protection due to its nature, such as health information, financial data, etc. The definition of sensitive data may vary between countries. For the purpose of this Data localization Policy, sensitive data refers to all customer data stored or processed through the Netilion services.


## 3. Legal and Regulatory Requirements

Endress+Hauser is committed to complying with data localization laws in countries where it operates. This includes storing and processing data within the respective country’s borders and adhering to all relevant legal and regulatory requirements.


## 4. Data Storage and Processing

Data collected in countries with data localization requirements will be stored and processed in dedicated data centers located within those countries. Cross-border data transfers will be restricted and conducted only in compliance with local laws.


## 5. Access and Security

Access to localized data will be restricted to authorized personnel only. Robust security measures, including encryption, access controls, and regular audits, will be implemented to ensure the protection of localized data. The access to the localized data and the usage of services for countries with data localization laws is based on the Netilion URL defined in this document.


## 6. Data Retention and Deletion

Localized data will be retained for the period required by local laws and regulations. Upon the expiration of the retention period, data will be securely deleted in accordance with established procedures.


## 7. Monitoring and Compliance

Regular audits will be conducted to ensure compliance with this Data Localization Policy. Any compliance issues will be reported to the relevant authorities and addressed promptly.


## 8. Data location and access path

The access path and location of the sensitive data depends on the customer location and the URL used to access the service. Unless otherwise defined by the country, the data will be stored according to the location for “rest of the world”.

<table width="100%" border="1">
  <thead>
    <tr>
      <th align="left" valign="top">Country</th>
      <th align="left" valign="top">Data Center location</th>
      <th align="left" valign="top">Access path</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td valign="top">China</td>
      <td valign="top">Alibaba Cloud Shanghai</td>
      <td valign="top">https://netilion.endress.com.cn</td>
    </tr>
    <tr>
      <td valign="top">India</td>
      <td valign="top">Amazon Web Services<br>Mumbai (ap-south-1)<br>Microsoft Azure<br>Pune (central-india)</td>
      <td valign="top">https://in.netilion.endress.com</td>
    </tr>
    <tr>
      <td valign="top">Rest of the World</td>
      <td valign="top">Amazon Web Services<br>Frankfurt / Dublin</td>
      <td valign="top">https://netilion.endress.com</td>
    </tr>
  </tbody>
</table>
`;
